import { AgGridReact } from "ag-grid-react";
import React, { Component } from "react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import XLSX from "xlsx";
import Button from "@material-ui/core/Button";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

    
const categorias = [
	{
		value: "1",
		label: "Experto en producto"
	},
	{
		value: "2",
		label: "Vacunación"
	},
	{
		value: "3",
		label: "Solution Selling"
	}
];

  
const gametypes = [
	{
		value: "0",
		label: "Pregunta/Respuesta"
	},
	{
		value: "1",
		label: "Conectar"
	},
	{
		value: "2",
		label: "Afirmación"
	}
];


class TopQuestions extends Component {
	constructor(props) {
		super(props);
		this.state = {
            category: "",
            level: "",
            levelcategory:"",
            levels: [],
			levelcategories: [],
			gametype: 0,
			columnDefs: [
				{ headerName: "Categoria", field: "categoryname", width: "150" },
				{ headerName: "Nivel", field: "levelname", width: "150" },
				{ headerName: "Subcategoria", field: "levelcategoryname", width: "150" },
				{ headerName: "Pregunta", field: "question", width: "400" },
                { headerName: "Correctas", field: "correctanswers", width: "100" },
                { headerName: "Incorrectas", field: "incorrectanswers", width: "100" }
			]
		};
    }

    
    componentDidMount() {}
    
    
	exportFile = () => {
		/* convert state to workbook */
		let cols = this.props.topquestions.map((info, i) => {
			return [
				info.categoryname,
				info.levelname,
				info.levelcategoryname,
				info.question,
				info.correctanswers, 
				info.incorrectanswers
			];
		});
		let hcols = [
			"Categoria",
			"Nivel",
			"Subcategoria",
			"Pregunta",
			"Correctas",
			"Incorrectas"
		];

		const exp = [[...hcols], ...cols];
		const ws = XLSX.utils.aoa_to_sheet(exp);
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "TopPreguntas");
		/* generate XLSX file and send to client */
		XLSX.writeFile(wb, "TopPreguntas.xlsx");
	};


	render() {
		return (
			<React.Fragment>
				<h2 style={{ width: "100%", textAlign: "left" }}>Ranking Preguntas</h2>
                <div style={{ width: "90%", textAlign: "left", marginBottom: "0px" }}>

                    <div style={{ float: "right" }}>

                        <Button
                                onClick={this.exportFile}
                                color="primary"
                                variant="contained"
                            >
                                Exportar a Excel
                            </Button>
                    </div> 
                </div>
                <br/>
                <br/><br/>
				<div
					className="ag-theme-balham"
					style={{ height: "75vh", width: "90%" }}
				>
					<AgGridReact
						enableSorting={true}
						enableFilter={true}
						columnDefs={this.state.columnDefs}
						rowData={this.props.topquestions}
					></AgGridReact>
				</div>
               
			</React.Fragment>
		);
	}
}

export default TopQuestions;
